module.exports = __webpack_public_path__ + "media/images/pic/team-0d30a510fd6dafa56f2058c48b65f354.jpeg";